export default "__VITE_ASSET__CuEtOD49__"